export default class RegisterFormColumnsNames {
    constructor(rawData = {}) {
      this.id = rawData.id;
      this.name = rawData.name;
      this.displayName = rawData.displayName;
      this.description = rawData.description;
      this.isActive = rawData.isActive;
    }
}